import { render } from "./Button.vue?vue&type=template&id=ce80970c&ts=true&lang=pug"
import script from "./Button.vue?vue&type=script&setup=true&lang=ts"
export * from "./Button.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__